import { Backpack, CloudRain, Compass, Route, Shield, Tent } from '@/ui/icons'

interface SuggestionChip {
  icon: typeof Tent
  label: string
  message: string
}

const TRIP_SUGGESTIONS: SuggestionChip[] = [
  {
    icon: Tent,
    label: 'Find dispersed campsites',
    message: 'Find dispersed camping spots near my trip campsites',
  },
  {
    icon: Backpack,
    label: 'Gear checklist',
    message: 'What gear should I bring for this trip?',
  },
  {
    icon: CloudRain,
    label: 'Weather risks',
    message: 'Are there any weather risks I should plan around for this trip?',
  },
  {
    icon: Route,
    label: 'Route feedback',
    message: 'Take a look at my route and let me know if anything stands out',
  },
]

const GENERAL_SUGGESTIONS: SuggestionChip[] = [
  {
    icon: Tent,
    label: 'Find dispersed camping',
    message: 'Help me find dispersed camping spots near a location',
  },
  {
    icon: Compass,
    label: 'Plan a weekend trip',
    message: 'Help me plan a weekend overlanding trip',
  },
  {
    icon: Backpack,
    label: 'Gear checklist',
    message: 'What gear do I need for backcountry overlanding?',
  },
  {
    icon: Shield,
    label: 'Safety planning',
    message: 'What should I consider for safety on a remote trip?',
  },
]

interface RangerSuggestionsProps {
  tripId?: string
  onSelect: (message: string) => void
  disabled?: boolean
}

export function RangerSuggestions({ tripId, onSelect, disabled }: RangerSuggestionsProps) {
  const suggestions = tripId ? TRIP_SUGGESTIONS : GENERAL_SUGGESTIONS

  return (
    <div className="grid w-full max-w-sm grid-cols-1 gap-2 sm:grid-cols-2">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion.label}
          type="button"
          onClick={() => onSelect(suggestion.message)}
          disabled={disabled}
          className="flex items-center gap-2 rounded-lg border border-border bg-background px-3 py-2.5 text-left text-xs font-medium text-foreground transition-colors hover:border-adventure-300 hover:bg-adventure-50 disabled:cursor-not-allowed disabled:opacity-50 dark:hover:bg-adventure-950/20"
        >
          <suggestion.icon className="h-4 w-4 shrink-0 text-adventure-600" />
          <span className="truncate">{suggestion.label}</span>
        </button>
      ))}
    </div>
  )
}
